<template>
  <v-app>
    <v-toolbar color="saPrimary" dark fixed app>
      <v-toolbar-side-icon @click="toggleDrawer"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-side-icon @click="notification_drawer = !notification_drawer">
        <v-icon>mdi-bell-outline</v-icon>
      </v-toolbar-side-icon> -->
    </v-toolbar>
    <Drawer v-model="toolbar.drawer" :admin_menu="admin_menu" />
    <v-content class="content-background">
      <router-view class="ma-3"></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Drawer from "@/components/Drawer"
import { mapFields } from "vuex-map-fields";
import { mapGetters, mapState } from "vuex";
import * as MENU from "@/menu";

export default {
  name: "AdminLayout",
  components: {
    Drawer,
  },
  data() {
    return {
      drawer: false,
      notification_drawer: false,
    };
  },

  computed: {
    ...mapFields("app", ["toolbar"]),
    admin_menu() {
      return MENU.ADMIN;
    },
  },
  methods: {
    toggleDrawer() {
      this.toolbar.drawer = !this.toolbar.drawer;
    },
  },
};
</script>

<style scoped>
.content-background {
  background-color: rgba(0, 124, 186, 0.04) !important;
}
</style>
